<div class="card m-3">
  <div class="card-header text-center">
    <h2>404</h2>
  </div>
  <div class="card-body text-center">
    <p>Siden findes desværre ikke</p>
  </div>
</div>
